(function () {
  function normalizeText(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();
  }

  function markTechnicalHeadings(root) {
    var scope = root && root.querySelectorAll ? root : document;

    var headings = scope.querySelectorAll(
      "h1, h2, h3, h4, .sb-section-title"
    );

    for (var i = 0; i < headings.length; i++) {
      var text = normalizeText(headings[i].textContent);

      if (
        text === "ESPECIFICACIONES TECNICAS DETALLADAS" ||
        text === "ESPECIFICACIONES TECNICAS EXTENSAS POR COMPONENTE" ||
        text === "ESPECIFICACIONES TECNICAS" ||
        text === "ESPECIFICACIONES"
      ) {
        headings[i].classList.add("sb-specs-heading");
      }
    }
  }

  function initSmartBusinessSpecsHeading() {
    markTechnicalHeadings(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initSmartBusinessSpecsHeading
    );
  } else {
    initSmartBusinessSpecsHeading();
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      markTechnicalHeadings(event.target);
    }
  );
})();